import React, { useState } from "react";
import { Box, Paper, Typography, FormControl, InputLabel, Select, MenuItem, Button } from "@mui/material";
import AgentDropZone from "../dnd/AgentDropZone";
import ToolItem from "../dnd/ToolItem";

function AssignTab({ agents, tools }) {
  const [selectedAgentId, setSelectedAgentId] = useState("");
  const [selectedToolName, setSelectedToolName] = useState("");
  const [assignResult, setAssignResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAssignTool = async () => {
    if (!selectedAgentId || !selectedToolName) return;
    setLoading(true);
    setAssignResult(null);
    try {
      const url = `${process.env.REACT_APP_API_URL_FLUXI}/api/ms/agent/config/${selectedAgentId}/tools/${selectedToolName}`;
      const res = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" } });
      const data = await res.json();
      setAssignResult(data);
    } catch (error) {
      setAssignResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleDropToolOnAgent = async (agent, toolName) => {
    setLoading(true);
    setAssignResult(null);
    try {
      const url = `${process.env.REACT_APP_API_URL_FLUXI}/api/ms/agent/config/${agent.agent_id}/tools/${toolName}`;
      const res = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" } });
      const data = await res.json();
      setAssignResult(data);
    } catch (error) {
      setAssignResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Asignar Tools a Agentes
      </Typography>
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="subtitle1">Asignar con Select</Typography>
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <FormControl sx={{ flex: 1 }}>
            <InputLabel>Agente</InputLabel>
            <Select
              value={selectedAgentId}
              label="Agente"
              onChange={(e) => setSelectedAgentId(e.target.value)}
            >
              {agents.map((ag) => (
                <MenuItem key={ag.id} value={ag.agent_id}>
                  {ag.agent_id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ flex: 1 }}>
            <InputLabel>Tool</InputLabel>
            <Select
              value={selectedToolName}
              label="Tool"
              onChange={(e) => setSelectedToolName(e.target.value)}
            >
              {tools.map((tl) => (
                <MenuItem key={tl.id} value={tl.tool_name}>
                  {tl.tool_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="contained" disabled={loading} onClick={handleAssignTool}>
            {loading ? "Asignando..." : "Asignar"}
          </Button>
        </Box>
      </Paper>
      <Paper sx={{ p: 2 }}>
        <Typography variant="subtitle1">Asignar con Drag & Drop</Typography>
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <Box sx={{ flex: 1, border: "1px solid #ccc", p: 1 }}>
            <Typography>Tools</Typography>
            {tools.map((tool) => (
              <ToolItem key={tool.id} tool={tool} />
            ))}
          </Box>
          <Box sx={{ flex: 2, border: "1px solid #ccc", p: 1 }}>
            <Typography>Agentes</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {agents.map((agent) => (
                <AgentDropZone
                  key={agent.id}
                  agent={agent}
                  onDropTool={handleDropToolOnAgent}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Paper>
      {assignResult && (
        <Paper sx={{ mt: 2, p: 2, backgroundColor: "#f5f5f5" }}>
          <Typography variant="subtitle1">Resultado Asignación:</Typography>
          <pre>{JSON.stringify(assignResult, null, 2)}</pre>
        </Paper>
      )}
    </Box>
  );
}

export default AssignTab;
